import React from 'react';
import { Check } from 'lucide-react';

const TechnicalSpecs = () => {
  const specs = [
    {
      category: 'Capacidade de Mixagem',
      items: [
        '48 canais stereo com processamento completo',
        '16 buses, 8 matrizes e 4 mains - todos stereo',
        '376 sinais de entrada e 374 de saída',
        'Flex-Channels: stereo, mono ou M/S em todos os 48 canais'
      ]
    },
    {
      category: 'Processamento de Áudio',
      items: [
        '16 engines de efeitos stereo com +80 FX profissionais',
        'Processamento de 40-bit para resolução máxima',
        'EQ e Dynamics em cada canal e bus',
        'Midas PRO mic preamps para transparência sem precedentes'
      ]
    },
    {
      category: 'Gravação e Interface',
      items: [
        'Interface USB de 48 canais para DAW',
        'Gravação multi-track de 64 canais em SD card',
        'Controle DAW via HUI e Mackie Control',
        'Integração com Cubase, Logic, ProTools, Ableton e mais'
      ]
    },
    {
      category: 'Conectividade',
      items: [
        'StageConnect exclusivo para até 32 canais via XLR único',
        '3 portas AES50 para até 144 I/O',
        'Dante, Waves SoundGrid via cartões de expansão',
        'Apps gratuitos para iOS, Android, Windows, Mac e Linux'
      ]
    }
  ];

  return (
    <section className="section-padding bg-black relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_4f5cf654-3a0c-4d01-a704-3b564425efff/artifacts/hxwvi6sm_FACE_WEB_Assets_Marketing-4-Desktop_2024-09-18_Rev.0.jpg"
          alt="WING Processing"
          className="w-full h-full object-cover object-center opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/70 to-black/80"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Especificações que você vai <span className="gradient-text">dominar</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              Engineered na Alemanha pelos criadores da X32
            </p>
          </div>

          {/* Specs Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {specs.map((spec, index) => (
              <div
                key={index}
                className="glass p-6 rounded-xl card-hover"
              >
                <h3 className="text-2xl font-bold text-yellow-400 mb-4">
                  {spec.category}
                </h3>
                <ul className="space-y-3">
                  {spec.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-300">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Highlight Box */}
          <div className="bg-gradient-to-r from-yellow-500/10 via-transparent to-green-500/10 border border-yellow-500/20 p-8 md:p-12 rounded-2xl">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-5xl font-bold text-yellow-400 mb-2">48</div>
                <div className="text-gray-300">Canais Stereo Completos</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-yellow-400 mb-2">376</div>
                <div className="text-gray-300">Sinais de Entrada</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-yellow-400 mb-2">40-bit</div>
                <div className="text-gray-300">Processamento de Áudio</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnicalSpecs;
